/*
*###############################################################################
*Module Name                   : VoucherTransferInDetails.js                   #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Thursday, January 6th 2022, 9:53:47 am        #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
import React, { useState } from "react"
import { Row, Col, Button } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPAlert from "../../../framework/widgets/DPAlert"
import { Numeric } from "../../../framework/validators/TextValidation" // Textbox input validations
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
const VoucherTransferInDetails = ({
  DataRow,
  setDetailRows,

  BookChange,

  SupplierCode,
  strFromLocation,
  menuCode,
  LocationCode
}) => {

  const changeRowValueChanges = (value, id, element) => {

    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    setDetailRows(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };




  function handleObjectChange(row, id) {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    setDetailRows(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = row;
      return newDataRow;
    });
  }


  function AddRow() {

    var detailRows = [...DataRow];
    detailRows.push({
      code: "",
      desc: "",
      VoucherFrom: "",
      VoucherTo: "",
      BookFrom: "",
      BookTo: "",
      id: DataRow.length + 1,
    })
    setDetailRows(detailRows)

  }


  function RemoveRow(id) {
    var filteredRows = DataRow.filter(x => x.id !== id);
    if (filteredRows.length == 0) {
      filteredRows.push({
        code: "",
        desc: "",
        VoucherFrom: "",
        VoucherTo: "",
        BookFrom: "",
        BookTo: "",
        id: 1,
      })
    }
    setDetailRows(filteredRows)
  }

  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <table style={{ fontSize: "11px" }} id={"VoucherPODet"}>
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th style={{ textAlign: "left" }}>Group Code</th>
                <th>&nbsp;</th>
                <th style={{ textAlign: "left" }}>Group Description </th>
                <th style={{ textAlign: "left" }}>Request Quantity</th>
                <th style={{ textAlign: "left" }}>Voucher Book No From</th>
                <th>&nbsp;</th>

                <th style={{ textAlign: "left" }}>Voucher Book No To</th>
                <th>&nbsp;</th>
                <th style={{ textAlign: "left" }}>Voucher No From</th>
                <th>&nbsp;</th>
                <th style={{ textAlign: "left" }}>Voucher No To</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {(DataRow || []).map((formRow, key) => (
                <TableRow
                  FormRow={formRow}
                  Key={key}
                  RemoveRow={RemoveRow}
                  // Disabled={blDiasableGrid}
                  Disabled={true}
                  BookChange={BookChange}
                  SupplierCode={SupplierCode}
                  strFromLocation={strFromLocation}
                  menuCode={menuCode}
                  LocationCode={LocationCode}
                  changeRowValueChanges={changeRowValueChanges}
                  handleObjectChange={handleObjectChange}
                />
              ))}
            </tbody>

          </table>
          {/* <Button
            onClick={() => {
              AddRow()
            }}
            disabled={blDiasableGrid}
            color="success"
            className="mt-1"
            size="sm"
          >
            <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
          </Button> */}
        </Col>


      </Row>
    </React.Fragment>
  )
}
export default VoucherTransferInDetails

const TableRow = ({ FormRow, Key, RemoveRow, Disabled, BookChange, SupplierCode, strFromLocation, menuCode, changeRowValueChanges, handleObjectChange }) => {

  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")


  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [modal_xlargeBook, setmodal_xlargeBook] = useState(false)
  const [modal_xlargeBookTo, setmodal_xlargeBookTo] = useState(false)
  const [modal_xlargeVoucherFrom, setmodal_xlargeVoucherFrom] = useState(false)
  const [modal_xlargeVoucherTo, setmodal_xlargeVoucherTo] = useState(false)

  const [Post, SetPost, getPost] = useState([])
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)


  const [groupFilter, SetGroupFilter] = useState('a')




  async function clickSearch() {
    tog_xlarge()
  }
  // voucher Book no
  async function clickBookFromSearch() {
    tog_xlargeBook()
  }

  // voucher Book no
  async function clickSearchToSearch() {
    tog_xlargeBookTo()
  }

  // Vocher No Search
  async function clickVoucherFromSearch() {
    tog_xlargeBookNoFrom()
  }

  async function clickVoucherToSearch() {
    tog_xlargeBookNoTo()
  }
  // Table Data



  //**Set the Default sort column and Sort order*/
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]



  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  function tog_xlargeBook() {
    setmodal_xlargeBook(!modal_xlargeBook)
    removeBodyCss()
  }

  function tog_xlargeBookTo() {
    setmodal_xlargeBookTo(!modal_xlargeBookTo)
    removeBodyCss()
  }

  function tog_xlargeBookNoFrom() {
    setmodal_xlargeVoucherFrom(!modal_xlargeVoucherFrom)
    removeBodyCss()
  }

  function tog_xlargeBookNoTo() {
    setmodal_xlargeVoucherTo(!modal_xlargeVoucherTo)
    removeBodyCss()
  }
  //** Columns to be populated/Displayed within the Search window */



  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.VCG_CODE, "txtcode" + Key)) {
      var currentRow = FormRow
      currentRow.code = row.VCG_CODE
      currentRow.desc = row.VCG_DESC
      handleObjectChange(currentRow, FormRow.id)
      setmodal_xlarge(!modal_xlarge)
    }
    else {
      setAlertDescription("Code already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
  }

  const Hed_SelectRowSearchBook = (e, row, isSelect, rowIndex) => {
    if (CodeBookFromValidation(row.VC_BOOKNO, "txtBookFrom" + Key, "txtcode" + Key, FormRow.code)) {

      var currentRow = FormRow
      currentRow.BookFrom = row.VC_BOOKNO
      handleObjectChange(currentRow, FormRow.id)

      setmodal_xlargeBook(!modal_xlargeBook)
      GetminVoucherNumber(row.VC_BOOKNO)

    }
    else {
      setAlertDescription("Book No already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
  }

  const Hed_SelectRowSearchBookTo = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.VC_BOOKNO, "txtBookTo" + Key)) {
      if (FormRow.BookFrom <= row.VC_BOOKNO) {

        var currentRow = FormRow
        currentRow.BookTo = row.VC_BOOKNO
        handleObjectChange(currentRow, FormRow.id)

        setmodal_xlargeBookTo(!modal_xlargeBookTo)
        CheckAllocatedBookNumber(FormRow.BookFrom, row.VC_BOOKNO, FormRow.code, strFromLocation)
        GetmaxVoucherNumber(row.VC_BOOKNO, FormRow.code, strFromLocation)
      }
      else {
        setAlertDescription("Book To Number should be greater than Book From Number")
        setAlertConfirmOption(4)
        setsweetAlertShow(true)
      }

    }
    else {
      setAlertDescription("Book No already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
  }

  const Hed_SelectRowSearchVoucherFrom = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.VC_NUMBER, "txtVoucherFrom" + Key)) {

      var currentRow = FormRow
      currentRow.VoucherFrom = row.VC_NUMBER
      handleObjectChange(currentRow, FormRow.id)

      setmodal_xlargeVoucherFrom(!modal_xlargeVoucherFrom)
    }
    else {
      setAlertDescription("Voucher No already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
  }
  const Hed_SelectRowSearchVoucherTo = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.VC_NUMBER, "txtVoucherTo" + Key)) {

      if (FormRow.VoucherFrom <= row.VC_NUMBER) {

        var currentRow = FormRow
        currentRow.VoucherTo = row.VC_NUMBER
        handleObjectChange(currentRow, FormRow.id)

        setmodal_xlargeVoucherTo(!modal_xlargeVoucherTo)
        CheckAllocatedVoucherNumber(FormRow.VoucherFrom, row.VC_NUMBER)
      }
      else {
        setAlertDescription("Voucher To Number should be greater than Voucher From Number")
        setAlertConfirmOption(4)
        setsweetAlertShow(true)
      }

    }
    else {
      setAlertDescription("Voucher No already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
  }
  function GetminVoucherNumber(value) {
    var currentRow = FormRow
    if (value != "" && FormRow.code != "" && strFromLocation != "") {
      fetch(`${ApiURL}VoucherTRO/getminVoucherNumber/${value}/${FormRow.code}/${strFromLocation}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {

            const dt = responseData.data[0]
            currentRow.VoucherFrom = dt.code
            handleObjectChange(currentRow, FormRow.id)

          } else {
            currentRow.BookFrom = ""
            currentRow.VoucherFrom = dt.code
            handleObjectChange(currentRow, FormRow.id)
          }
        })
    } else {
      currentRow.BookFrom = ""
      currentRow.VoucherFrom = dt.code
      handleObjectChange(currentRow, FormRow.id)
    }
  }

  function GetmaxVoucherNumber(value) {
    var currentRow = FormRow
    if (value != "" && FormRow.code != "" && strFromLocation != "") {
      fetch(`${ApiURL}VoucherTRO/getmaxVoucherNumber/${value}/${FormRow.code}/${strFromLocation}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {

            const newArray = responseData.data[0]

            currentRow.VoucherTo = newArray.code
            handleObjectChange(currentRow, FormRow.id)

          } else {

            currentRow.BookTo = ""
            currentRow.VoucherTo = ""
            handleObjectChange(currentRow, FormRow.id)
          }
        })
    } else {

      currentRow.BookTo = ""
      currentRow.VoucherTo = ""
      handleObjectChange(currentRow, FormRow.id)
    }
  }

  function CheckAllocatedBookNumber(FromBook, ToBook, code, strFromLocation) {
    var currentRow = FormRow
    if (ToBook != "" && FromBook != "" && code != "" && strFromLocation != "") {
      fetch(`${ApiURL}VoucherTRO/CheckAllocatedBookNumber/${FromBook}/${ToBook}/${code}/${strFromLocation}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {
            setAlertDescription("This Following Voucher number are already allocated " + responseData.data)
            setAlertConfirmOption(4)
            setsweetAlertShow(true)

            currentRow.BookTo = ""
            currentRow.VoucherTo = ""
            handleObjectChange(currentRow, FormRow.id)
          }
        })
    } else {
      // setVoucherTo("")

    }
  }

  function CheckAllocatedVoucherNumber(FromVoucher, ToVoucher, code, strFromLocation) {
    var currentRow = FormRow
    if (ToVoucher != "" && FromVoucher != "" && code != "" && strFromLocation != "") {

      fetch(`${ApiURL}VoucherTRO/CheckAllocatedVoucherNumber/${FromVoucher}/${ToVoucher}/${code}/${strFromLocation}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {
            setAlertDescription("This Following Voucher number are already allocated " + responseData.data)
            setAlertConfirmOption(4)
            setsweetAlertShow(true)

            currentRow.VoucherTo = ""
            handleObjectChange(currentRow, FormRow.id)
          }
        })
    } else {
      // setVoucherTo("")

    }
  }
  function VoucherGroupCodeSearch(value) {
    var currentRow = FormRow
    if (value != "") {

      fetch(`${ApiURL}VoucherGroup/search/${value}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {

            const dt = responseData.data[0]

            currentRow.desc = dt.strName
            handleObjectChange(currentRow, FormRow.id)


          } else {
            currentRow.code = ""
            currentRow.desc = ""
            handleObjectChange(currentRow, FormRow.id)
          }
        })
    } else {
      currentRow.code = ""
      currentRow.desc = ""
      handleObjectChange(currentRow, FormRow.id)
    }
  }
  function BookCodeSearch(value) {
    var currentRow = FormRow
    if (value != "") {

      fetch(`${ApiURL}VoucherTRO/searchBookNo/${value}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {

            if (FormRow.code == "" || strFromLocation == "") {
              setAlertDescription(FormRow.code == "" ? "Please Select Voucher Group" : "Please Select From Location")
              setAlertConfirmOption(4)
              setsweetAlertShow(true)

              currentRow.BookFrom = ""
              currentRow.VoucherFrom = ""
              handleObjectChange(currentRow, FormRow.id)

              return
            }
            const dt = responseData.data[0]

            currentRow.VoucherFrom = dt.bookcode
            handleObjectChange(currentRow, FormRow.id)

            GetminVoucherNumber(FormRow.BookFrom, FormRow.code, strFromLocation)


          } else {
            currentRow.BookFrom = ""
            currentRow.VoucherFrom = ""
            handleObjectChange(currentRow, FormRow.id)
          }
        })
    } else {
      currentRow.BookFrom = ""
      currentRow.VoucherFrom = ""
      handleObjectChange(currentRow, FormRow.id)
    }
  }

  function BookCodeSearchTo(value) {
    var currentRow = FormRow
    if (value != "") {

      fetch(`${ApiURL}VoucherTRO/searchBookNo/${value}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {
            const dt = responseData.data[0]
            currentRow.BookTo = dt.bookcode
            handleObjectChange(currentRow, FormRow.id)

            GetmaxVoucherNumber(FormRow.BookTo, FormRow.code, strFromLocation)
          } else {
            currentRow.BookTo = ""
            currentRow.VoucherTo = ""
            handleObjectChange(currentRow, FormRow.id)
          }
        })
    } else {

      currentRow.BookTo = ""
      currentRow.VoucherTo = ""
      handleObjectChange(currentRow, FormRow.id)

    }
  }
  function VoucherCodeSearch(value) {
    var currentRow = FormRow
    if (value != "") {

      fetch(`${ApiURL}VoucherTRO/searchVoucherNo/${value}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {
            const dt = responseData.data[0]
            currentRow.VoucherFrom = dt.code
            handleObjectChange(currentRow, FormRow.id)

          } else {
            currentRow.VoucherFrom = ""
            handleObjectChange(currentRow, FormRow.id)
          }
        })
    } else {
      currentRow.VoucherFrom = ""
      handleObjectChange(currentRow, FormRow.id)

    }
  }
  function VoucherCodeSearchTo(value) {

    var currentRow = FormRow

    if (value != "") {

      fetch(`${ApiURL}VoucherTRO/searchVoucherNo/${value}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {

            const dt = responseData.data[0]
            currentRow.VoucherTo = dt.code
            handleObjectChange(currentRow, FormRow.id)

          } else {
            currentRow.VoucherTo = ""
            handleObjectChange(currentRow, FormRow.id)
          }
        })
    } else {
      currentRow.VoucherTo = ""
      handleObjectChange(currentRow, FormRow.id)
    }
  }

  //* Code Validation from repeating*/
  const CodeValidation = (strCode, id) => {
    var tbl = document.getElementById("VoucherPODet")
    if (tbl != null) {
      let rowCount = tbl.tBodies[0].rows.length
      for (let i = 0; i < rowCount; i++) {
        var txtcode = document.getElementById("txtcode" + i)
        if ("txtcode" + i != id && txtcode.value == strCode) {
          return false
        }
      }
    }
    return true
  }
  const CodeBookFromValidation = (strCode, id) => {
    var tbl = document.getElementById("VoucherPODet")
    if (tbl != null) {
      let rowCount = tbl.tBodies[0].rows.length
      for (let i = 0; i < rowCount; i++) {
        var txtcode = document.getElementById("txtBookFrom" + i)
        if ("txtBookFrom" + i != id && txtcode.value == strCode) {
          return false
        }
      }
    }
    return true
  }
  //* End Code Validation   */
  return (
    <tr key={FormRow.id}>
      <td>
        {" "}
        <Row className="mb-0">
          <Col md="12">{Key + 1}</Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="3"
              id={"txtcode" + Key}
              value={FormRow.code}
              disabled={Disabled}
              onChange={e => {
                // setcode(e.target.value)
                changeRowValueChanges(e.target.value, FormRow.id, "code")
              }}
              onBlur={e => {
                if (CodeValidation(e.target.value, "txtcode" + Key)) {
                  VoucherGroupCodeSearch(e.target.value)
                } else {
                  setAlertDescription("Code already used")
                  setAlertConfirmOption(4)
                  setsweetAlertShow(true)
                }

              }}
            />
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              color="success"
              disabled={Disabled}
              id={"btnSearch" + Key}
              onClick={clickSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "250px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtdesc" + Key}
              value={FormRow.desc}
              disabled={true}
              onChange={e => {
                changeRowValueChanges(e.target.value, FormRow.id, "desc")
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              id={"reqqty" + Key}
              value={FormRow.Reqqty}
              disabled={true}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              id={"txtBookFrom" + Key}
              value={FormRow.BookFrom}
              disabled={Disabled}
              onChange={e => {
                let value1 = Numeric(e.target, 15, 0, false)
                changeRowValueChanges(value1, FormRow.id, "BookFrom")
              }}
              onBlur={e => {
                BookCodeSearch(e.target.value)
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              color="success"
              disabled={Disabled}
              id={"btnBookfromSearch" + Key}
              onClick={clickBookFromSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              id={"txtBookTo" + Key}
              value={FormRow.BookTo}
              disabled={Disabled}
              onChange={e => {
                let value1 = Numeric(e.target, 15, 0, false)
                changeRowValueChanges(value1, FormRow.id, "BookTo")
              }}
              onBlur={e => {
                BookCodeSearchTo(e.target.value)

              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              color="success"
              disabled={Disabled}
              id={"btnBookToSearch" + Key}
              onClick={clickSearchToSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              id={"txtVoucherFrom" + Key}
              value={FormRow.VoucherFrom}
              disabled={Disabled}
              onChange={e => {
                let value1 = Numeric(e.target, 15, 0, false)
                changeRowValueChanges(value1, FormRow.id, "VoucherFrom")
              }}
              onBlur={e => {
                VoucherCodeSearch(e.target.value)
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              color="success"
              disabled={Disabled}
              id={"btnVoucherFromSearch" + Key}
              onClick={clickVoucherFromSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={Disabled}
              id={"txtVoucherTo" + Key}
              value={FormRow.VoucherTo}
              onChange={e => {
                let value1 = Numeric(e.target, 15, 0, false)
                changeRowValueChanges(value1, FormRow.id, "VoucherTo")
              }}
              onBlur={e => {
                VoucherCodeSearchTo(e.target.value)
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              color="success"
              disabled={Disabled}
              id={"btnVoucherToSearch" + Key}
              onClick={clickVoucherToSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>

      <td>
        <Row className="mb-0">
          <Col md="1">
            <Button
              outline
              disabled={Disabled}
              color="danger"
              onClick={e => {
                RemoveRow(FormRow.id)
              }}
              size="sm"
            >
              <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
            </Button>
          </Col>{" "}
        </Row>
      </td>

      <DPSearchBoxDynamic
        searchData={[]}
        columns={[]}
        defaultSorted={defaultSorted}
        mainTitle={"Voucher Group Detail Search"}
        SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlarge}
        toggle={tog_xlarge}
        getSelect={Hed_SelectRowSearch}
        APIURL={ApiURL}
        URLPath={"VOUTGRP"}
        MenuCode={menuCode}
        KeyVal={'GRP'}
        searchBy={'VCG_CODE'}
        FilterStr={groupFilter}
      />

      <DPSearchBoxDynamic
        searchData={[]}
        columns={[]}
        defaultSorted={defaultSorted}
        mainTitle={"Voucher Number Detail Search"}
        SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlargeBook}
        toggle={tog_xlargeBook}
        getSelect={Hed_SelectRowSearchBook}
        APIURL={ApiURL}
        URLPath={"VOUTBNOF"}
        MenuCode={menuCode}
        KeyVal={'BNF'}
        searchBy={'VC_BOOKNO'}
        FilterStr={`AND VC_LOC=${strFromLocation} and VC_CATEGORY=${FormRow.code}`}
      />

      <DPSearchBoxDynamic
        searchData={[]}
        columns={[]}
        defaultSorted={defaultSorted}
        mainTitle={"Voucher Number Detail Search"}
        SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlargeBookTo}
        toggle={tog_xlargeBookTo}
        getSelect={Hed_SelectRowSearchBookTo}
        APIURL={ApiURL}
        URLPath={"VOUTBNOT"}
        MenuCode={menuCode}
        KeyVal={'BNF'}
        searchBy={'VC_BOOKNO'}
        FilterStr={`AND VC_LOC=${strFromLocation} and VC_CATEGORY=${FormRow.code}`}
      />

      <DPSearchBoxDynamic
        searchData={[]}
        columns={[]}
        defaultSorted={defaultSorted}
        mainTitle={"Voucher Number Detail Search"}
        SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlargeVoucherFrom}
        toggle={tog_xlargeBookNoFrom}
        getSelect={Hed_SelectRowSearchVoucherFrom}
        APIURL={ApiURL}
        URLPath={"VOUTVNF"}
        MenuCode={menuCode}
        KeyVal={'VNO'}
        searchBy={'VC_NUMBER'}
        FilterStr={`AND VC_LOC=${strFromLocation} and VC_CATEGORY=${FormRow.code}`}
      />

      <DPSearchBoxDynamic
        searchData={[]}
        columns={[]}
        defaultSorted={defaultSorted}
        mainTitle={"Voucher Number Detail Search"}
        SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlargeVoucherTo}
        toggle={tog_xlargeBookNoTo}
        getSelect={Hed_SelectRowSearchVoucherTo}
        APIURL={ApiURL}
        URLPath={"VOUTVNT"}
        MenuCode={menuCode}
        KeyVal={'VNO'}
        searchBy={'VC_NUMBER'}
        FilterStr={`AND VC_LOC=${strFromLocation} and VC_CATEGORY=${FormRow.code}`}
      />

      <DPAlert
        confirm_both={sweetAlertShow}
        title={"Voucher Transfer In Note !"}
        description={AlertDescription}
        showCancel={false}
        btnColor={"success"}
        cancelColor={"danger"}
        onConfirm={() => {
          setsweetAlertShow(false)
          // setcode("")
        }}
        btnYes={"OK"}


      />


    </tr>
  )
}